import React, { createContext, useContext, useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const ClientContext = createContext(null);

export function ClientProvider({ children }) {
  const { user, isSuperAdmin } = useAuth();
  const [selected, setSelected] = useState(localStorage.getItem("vsm_client") || null);

  const { data: clients = [], isLoading } = useQuery({
    queryKey: ["clients"],
    queryFn: async () => (await api.get("/clients")).data,
    enabled: !!user,
  });

  useEffect(() => {
    if (!clients.length) return;
    if (isSuperAdmin) {
      if (!selected) setSelected("all");
    } else {
      // Non super-admin: lock to first accessible client if invalid
      const ids = clients.map((c) => c.id);
      if (!selected || (selected !== "all" && !ids.includes(selected))) {
        setSelected(clients[0].id);
      }
    }
  }, [clients, isSuperAdmin]); // eslint-disable-line

  const setSelectedClient = (id) => {
    setSelected(id);
    localStorage.setItem("vsm_client", id);
  };

  const currentClient = selected && selected !== "all"
    ? clients.find((c) => c.id === selected) || null
    : null;

  const isAll = selected === "all";

  return (
    <ClientContext.Provider value={{ clients, selected, setSelectedClient, currentClient, isAll, isLoading }}>
      {children}
    </ClientContext.Provider>
  );
}

export const useClient = () => useContext(ClientContext);
